// MOD-CUSTOM: Page-wide USP engine — resolution functions shared across all USP surfaces

window.UspEngine = (function () {
  'use strict';

  function getActivePersonaHandle() {
    var paramHandle = new URLSearchParams(window.location.search).get('ph');
    if (paramHandle) return paramHandle;
    var cookieMatch = document.cookie.match(/(?:^|;\s*)_persona_handle=([^;]*)/);
    return cookieMatch ? decodeURIComponent(cookieMatch[1]) : 'default';
  }

  function findByHandle(array, handle) {
    for (var index = 0; index < array.length; index++) {
      if (array[index].handle === handle) return array[index];
    }
    return null;
  }

  // Returns the first resolved text across priorityLists (highest priority first).
  function resolveUspText(priorityLists, dictionary) {
    var results = resolveUspList(priorityLists, dictionary, 1);
    return results.length ? results[0].text : '';
  }

  // Returns up to `limit` deduplicated handles across priorityLists, without requiring dictionary text.
  // Used for icon-only surfaces like badges where text resolution is not needed.
  function resolveUspIcons(priorityLists, limit) {
    var seen    = {};
    var handles = [];
    for (var priorityIndex = 0; priorityIndex < priorityLists.length; priorityIndex++) {
      var typeHandles = priorityLists[priorityIndex] || [];
      for (var typeIndex = 0; typeIndex < typeHandles.length; typeIndex++) {
        if (handles.length >= limit) break;
        var handle = typeHandles[typeIndex];
        if (!seen[handle]) {
          seen[handle] = true;
          handles.push(handle);
        }
      }
      if (handles.length >= limit) break;
    }
    return handles;
  }

  // Returns up to `limit` resolved { handle, text } items across priorityLists.
  function resolveUspList(priorityLists, dictionary, limit) {
    var seen    = {};
    var results = [];
    for (var priorityIndex = 0; priorityIndex < priorityLists.length; priorityIndex++) {
      var typeHandles = priorityLists[priorityIndex] || [];
      for (var typeIndex = 0; typeIndex < typeHandles.length; typeIndex++) {
        if (results.length >= limit) break;
        var handle = typeHandles[typeIndex];
        if (!seen[handle]) {
          seen[handle] = true;
          var entry = dictionary[handle];
          if (entry && entry.text) results.push({ handle: handle, text: entry.text });
        }
      }
      if (results.length >= limit) break;
    }
    return results;
  }

  // Collapses priorityLists to a single level when a lock flag is set at that level.
  // lockFlags must be in the same order as priorityLists (L3, L2, L1).
  function applyLockFlag(priorityLists, lockFlags) {
    for (var index = 0; index < lockFlags.length; index++) {
      if (lockFlags[index] && priorityLists[index] && priorityLists[index].length > 0) {
        return [priorityLists[index]];
      }
    }
    return priorityLists;
  }

  function getIcon(handle) {
    var iconElement = document.querySelector('#usp-icon-registry [data-icon="' + handle + '"]');
    return iconElement ? iconElement.innerHTML : '';
  }

  // Fills all [data-usp-pdp-surface] slots on the PDP for a single product.
  // productId: the Shopify product ID to resolve.
  // productDataArray: parsed contents of #usp-pdp-product-data.
  // personaDataArray: parsed contents of #usp-persona-surface-data (page-wide).
  function renderUspOnPage(productId, productDataArray, personaDataArray) {
    var activePersonaHandle = getActivePersonaHandle();
    var defaultPersona      = findByHandle(personaDataArray, 'default') || {};
    var activePersona       = activePersonaHandle !== 'default'
                                ? findByHandle(personaDataArray, activePersonaHandle) || {}
                                : {};

    var productDatum = null;
    for (var index = 0; index < productDataArray.length; index++) {
      if (productDataArray[index].productId === productId) { productDatum = productDataArray[index]; break; }
    }
    if (!productDatum) return;

    var dictionary       = productDatum.dictionary || {};
    var productOverrides = productDatum.l2         || {};

    // Priority order: L3 (active persona) → L2 (product override) → L1 (default persona)
    var surfaces = {
      subheadline:      [activePersona.subheadline      || [], productOverrides.subheadline      || [], defaultPersona.subheadline      || []],
      overview_bullets: [activePersona.overview_bullets || [], productOverrides.overview_bullets || [], defaultPersona.overview_bullets || []],
      macro_bullets:    [activePersona.macro_bullets    || [], productOverrides.macro_bullets    || [], defaultPersona.macro_bullets    || []],
      badges:           [activePersona.badges           || [], productOverrides.badges           || [], defaultPersona.badges           || []]
    };

    var subheadlineElement = document.querySelector('[data-usp-pdp-surface="subheadline"]');
    if (subheadlineElement) {
      subheadlineElement.textContent = resolveUspText(surfaces.subheadline, dictionary);
    }

    var overviewBulletsList = document.querySelector('[data-usp-pdp-surface="overview_bullets"]');
    if (overviewBulletsList) {
      var overviewItems = resolveUspList(surfaces.overview_bullets, dictionary, 5);
      overviewBulletsList.innerHTML = '';
      overviewItems.forEach(function (item) {
        var listItem = document.createElement('li');
        listItem.setAttribute('data-usp-handle', item.handle);
        var iconWrapper = document.createElement('span');
        iconWrapper.className = 'custom-usp-pdp-callout__icon';
        iconWrapper.innerHTML = getIcon(item.handle);
        listItem.appendChild(iconWrapper);
        var textSpan = document.createElement('h5');
        textSpan.textContent = item.text;
        listItem.appendChild(textSpan);
        overviewBulletsList.appendChild(listItem);
      });
    }

    var macroBulletsList = document.querySelector('[data-usp-pdp-surface="macro_bullets"]');
    if (macroBulletsList) {
      var macroPriorityLists = applyLockFlag(surfaces.macro_bullets, [
        activePersona.macro_bullets_locked    || false,
        productOverrides.macro_bullets_locked || false,
        defaultPersona.macro_bullets_locked   || false
      ]);
      var macroItems = resolveUspList(macroPriorityLists, dictionary, 5);
      macroBulletsList.innerHTML = '';
      macroItems.forEach(function (item) {
        var listItem = document.createElement('li');
        listItem.setAttribute('data-usp-handle', item.handle);
        var checkWrapper = document.createElement('span');
        checkWrapper.className = 'custom-usp-pdp-bullets__check';
        checkWrapper.innerHTML = getIcon('checkmark');
        listItem.appendChild(checkWrapper);
        var textSpan = document.createElement('span');
        textSpan.textContent = item.text;
        listItem.appendChild(textSpan);
        macroBulletsList.appendChild(listItem);
      });
    }

    var badgesContainers = document.querySelectorAll('[data-usp-pdp-surface="badges"]');
    if (badgesContainers.length) {
      var badgePriorityLists = applyLockFlag(surfaces.badges, [
        activePersona.badges_locked    || false,
        productOverrides.badges_locked || false,
        defaultPersona.badges_locked   || false
      ]);
      var badgeHandles = resolveUspIcons(badgePriorityLists, 10);
      badgesContainers.forEach(function (badgesContainer) {
        badgesContainer.innerHTML = '';
        badgeHandles.forEach(function (handle) {
          var iconHTML = getIcon(handle);
          if (iconHTML) {
            var iconSpan = document.createElement('span');
            iconSpan.setAttribute('data-usp-handle', handle);
            iconSpan.setAttribute('aria-hidden', 'true');
            iconSpan.innerHTML = iconHTML;
            badgesContainer.appendChild(iconSpan);
          }
        });
      });
    }
  }

  // Fills all [data-product-id] cards inside cardsContainer using the resolved USP priority waterfall.
  // productDataArray: parsed contents of the widget's usp-product-data JSON blob.
  // personaDataArray: parsed contents of #usp-persona-surface-data (page-wide).
  function renderUspInContainer(cardsContainer, productDataArray, personaDataArray) {
    var activePersonaHandle = getActivePersonaHandle();
    var defaultPersona      = findByHandle(personaDataArray, 'default') || {};
    var activePersona       = activePersonaHandle !== 'default'
                                ? findByHandle(personaDataArray, activePersonaHandle) || {}
                                : {};

    cardsContainer.querySelectorAll('[data-product-id]').forEach(function (card) {
      var productId    = parseInt(card.getAttribute('data-product-id'), 10);
      var productDatum = null;
      for (var index = 0; index < productDataArray.length; index++) {
        if (productDataArray[index].productId === productId) { productDatum = productDataArray[index]; break; }
      }
      if (!productDatum) return;

      var dictionary       = productDatum.dictionary || {};
      var productOverrides = productDatum.l2         || {};

      // Priority order: L3 (active persona) → L2 (product override) → L1 (default persona)
      var surfaces = {
        best_for:             [activePersona.best_for             || [], productOverrides.best_for             || [], defaultPersona.best_for             || []],
        comparison_condensed: [activePersona.comparison_condensed || [], productOverrides.comparison_condensed || [], defaultPersona.comparison_condensed || []]
      };

      var bestForElement = card.querySelector('[data-usp-surface="best_for"]');
      if (bestForElement) bestForElement.textContent = resolveUspText(surfaces.best_for, dictionary);

      var condensedList = card.querySelector('[data-usp-surface="comparison_condensed"]');
      if (condensedList) {
        var items = resolveUspList(surfaces.comparison_condensed, dictionary, 3);
        condensedList.innerHTML = '';
        items.forEach(function (item) {
          var listItem = document.createElement('li');
          listItem.setAttribute('data-usp-handle', item.handle);
          listItem.innerHTML = getIcon('checkmark');
          var textSpan = document.createElement('span');
          textSpan.textContent = item.text;
          listItem.appendChild(textSpan);
          condensedList.appendChild(listItem);
        });
      }
    });
  }

  return {
    getActivePersonaHandle: getActivePersonaHandle,
    resolveUspText:         resolveUspText,
    resolveUspList:         resolveUspList,
    resolveUspIcons:        resolveUspIcons,
    getIcon:                getIcon,
    renderUspOnPage:        renderUspOnPage,
    renderUspInContainer:   renderUspInContainer
  };
}());

document.dispatchEvent(new CustomEvent('usp-engine:ready'));
